import TransFormToOrganizationReportView from './transform-to-organization-report-view'

export default TransFormToOrganizationReportView
